export default __webpack_public_path__ + "static/media/endorsement-tac.0e78063a.png";